import { queryOptions } from '@tanstack/react-query'
import { apiGet, apiPostJson } from './client'

/**
 * Settings > Securitee > XDR > SIEM groups (API: `App\Securitee\Siem\SiemGroupsAdmin`):
 * o conexiune Wazuh pe grup de firme. Administratorul de platforma face,
 * opreste, sterge grupuri si muta firme; adminul unui furnizor vede numai
 * Shared si grupurile furnizorului lui.
 */

export interface SiemGroupRow {
  ID: number
  name: string
  owner_sp: number | null
  /** 1 = oprit: evenimentele firmelor lui asteapta */
  disabled: number
  /** firme puse direct pe grup (subsidiarele lor urmeaza) */
  companies: number
  last_forward_at: string | null
  last_alert_read_at: string | null
  can_edit: boolean
}

export interface SiemGroupsPage {
  groups: SiemGroupRow[]
  /** firmele de varf fara grup (numai pentru administratorul de platforma) */
  unassigned: { ID: number; name: string }[]
  /** administrator de platforma: face / opreste / sterge grupuri, muta firme */
  can_admin: boolean
}

export interface SiemGroupCompany {
  ID: number
  name: string
  set_at: string | null
  set_by_name: string
}

export interface SiemGroupHistoryRow {
  created_at: string
  user_name: string
  action: 'created' | 'disabled' | 'enabled' | 'removed' | 'connection' | 'webhook' | 'company_set' | string
  old_value: string | null
  new_value: string | null
  company_name: string | null
}

export const SIEM_GROUPS_KEY = ['securitee', 'siem-groups'] as const

export function siemGroupsQuery() {
  return queryOptions({ queryKey: SIEM_GROUPS_KEY, queryFn: () => apiGet<SiemGroupsPage>('/securitee/siem-groups') })
}

export function siemGroupCompaniesQuery(group: number) {
  return queryOptions({
    queryKey: [...SIEM_GROUPS_KEY, group, 'companies'],
    queryFn: () => apiGet<{ companies: SiemGroupCompany[] }>(`/securitee/siem-groups/${group}/companies`),
  })
}

export function siemGroupHistoryQuery(group: number) {
  return queryOptions({
    queryKey: [...SIEM_GROUPS_KEY, group, 'history'],
    queryFn: () => apiGet<{ history: SiemGroupHistoryRow[] }>(`/securitee/siem-groups/${group}/history`),
  })
}

export function createSiemGroup(name: string): Promise<{ group: number }> {
  return apiPostJson('/securitee/siem-groups', { name })
}

export function setSiemGroupState(group: number, state: 'disable' | 'enable'): Promise<{ ok: boolean }> {
  return apiPostJson(`/securitee/siem-groups/${group}/${state}`, {})
}

export function removeSiemGroup(group: number): Promise<{ ok: boolean }> {
  return apiPostJson(`/securitee/siem-groups/${group}/remove`, {})
}

/** Pune sau muta o firma de varf in grup (numai administratorul de platforma). */
export function setCompanySiemGroup(company: number, group: number): Promise<{ ok: boolean }> {
  return apiPostJson(`/securitee/siem-companies/${company}/group`, { group })
}
